module.exports = __webpack_public_path__ + "static/media/player3.e5d798a6.png";